// TODO: Refactor to reduce redundancy.
export var SAIcons;
(function (SAIcons) {
    SAIcons["addContact"] = "addContact";
    SAIcons["adjuster"] = "adjuster";
    SAIcons["alert"] = "alert";
    SAIcons["arrowRight"] = "arrowRight";
    SAIcons["auto"] = "auto";
    SAIcons["bank"] = "bank";
    SAIcons["bell"] = "bell";
    SAIcons["billing"] = "billing";
    SAIcons["calculate"] = "calculate";
    SAIcons["checklist"] = "checklist";
    SAIcons["checkmark"] = "checkmark";
    SAIcons["chevronDown"] = "chevronDown";
    SAIcons["chevronDownBold"] = "chevronDownBold";
    SAIcons["chevronLeft"] = "chevronLeft";
    SAIcons["chevronLeftBold"] = "chevronLeftBold";
    SAIcons["chevronRight"] = "chevronRight";
    SAIcons["chevronRightBold"] = "chevronRightBold";
    SAIcons["chevronUp"] = "chevronUp";
    SAIcons["chevronUpBold"] = "chevronUpBold";
    SAIcons["chevronsDown"] = "chevronsDown";
    SAIcons["chevronsLeft"] = "chevronsLeft";
    SAIcons["chevronsRight"] = "chevronsRight";
    SAIcons["chevronsUp"] = "chevronsUp";
    SAIcons["claim"] = "claim";
    SAIcons["clock"] = "clock";
    SAIcons["dash"] = "dash";
    SAIcons["documentPDF"] = "documentPDF";
    SAIcons["document"] = "document";
    SAIcons["download"] = "download";
    SAIcons["error"] = "error";
    SAIcons["eye"] = "eye";
    SAIcons["filter"] = "filter";
    SAIcons["glassDamage"] = "glassDamage";
    SAIcons["help"] = "help";
    SAIcons["home"] = "home";
    SAIcons["idCard"] = "idCard";
    SAIcons["info"] = "info";
    SAIcons["information"] = "information";
    SAIcons["injury"] = "injury";
    SAIcons["logout"] = "logout";
    SAIcons["mail"] = "mail";
    SAIcons["medicalSuitcase"] = "medicalSuitcase";
    SAIcons["menuHamburger"] = "menuHamburger";
    SAIcons["menuKabob"] = "menuKabob";
    SAIcons["menuProfile"] = "menuProfile";
    SAIcons["more"] = "more";
    SAIcons["pawPrint"] = "pawPrint";
    SAIcons["pencil"] = "pencil";
    SAIcons["person"] = "person";
    SAIcons["personCircle"] = "personCircle";
    SAIcons["personDouble"] = "personDouble";
    SAIcons["personHeadset"] = "personHeadset";
    SAIcons["phone"] = "phone";
    SAIcons["pin"] = "pin";
    SAIcons["plus"] = "plus";
    SAIcons["redirect"] = "redirect";
    SAIcons["refresh"] = "refresh";
    SAIcons["roadsideAssistance"] = "roadsideAssistance";
    SAIcons["search"] = "search";
    SAIcons["shield"] = "shield";
    SAIcons["success"] = "success";
    SAIcons["trash"] = "trash";
    SAIcons["umbrella"] = "umbrella";
    SAIcons["warning"] = "warning";
    SAIcons["x"] = "x";
})(SAIcons || (SAIcons = {}));
//# sourceMappingURL=icon.options.js.map